module.exports = __webpack_public_path__ + "static/media/Osim-AI-learning.83ccd2d2.png";